const role = {
  admin: 'admin',
  user: 'user',
};

export const isAdmin = userRole => userRole === role.admin;

export default {
  isAdmin,
};
